<!-- <div class="card flex flex-col gap-4 w-full"></div>
    <div class="font-semibold text-xl">Advanced</div> -->

<!-- 
Fields για Νέα Εγγραφή
    1. Παρεχόμενη Υπηρεσία: Απαξ, recurringService, continuousService
    2. Εγκατάσταση (Υποκατάστημα)
    
    3. Αριθμός Κυκλοφορίας
        3.1 Όχημα Αλλοδαπής
        3.2 Εργοστάσιο Οχήματος
        3.3 Κατηγορία Οχήματος
        
    4. Ημερομηνία Εισόδου
    5. Ώρα Εισόδου

    7. Συσχετιζόμενος Α/Α Ψηφιακού Πελατολογίου
    
    8. Κατηγορία Παρεχόμενης Υπηρεσίας (ProvidedServiceCategory)
    9. Εϊδος Παραστατικού (1 = ΑΛΠ/ΑΠΥ, 2 = ΤΙΜΟΛΟΓΙΟ, 3 = ΑΛΠ/ΑΠΥ-ΦΗΜ)
        Για Τιμολόγιο:
        Α.Φ.Μ Αντισυμβαλόμενου
        Χώρα (Προεπιλεγμένη η Ελλάδα)

    10. Συμφωνηθέν Ποσό

    11. Παρατηρήσεις

Buttons:
    Αποθήκευση
    ΧΧΧΧ Διαβίβαση (Όταν δεν έχει παρει Α/Α Ψηφιακού Πελατολογίου)
    ΧΧΧΧ Ολοκλήρωση - Έξοδος (Όταν έχει πάρει Α/Α Ψηφιακού Πελατολογίου) 
-->

<!-- <pre>
    {{ dclFormGroup?.value | json }}
</pre> -->

<input type="text" style="display: none" />
@if (dclFormGroup) {
    <div [formGroup]="$any(dclFormGroup)">
        @let customerId = dclFormGroup.controls.CustomerId?.value;
        @let DCLNewId = dclFormGroup.controls.DCLNewId?.value;
        @let creationDateTime = dclFormGroup.controls.CreationDateTime?.value;
        @let completionDateTime =
            dclFormGroup.controls.CompletionDateTime?.value;
        @let providedServiceCategory =
            dclFormGroup.controls.ProvidedServiceCategory?.value;

        @let invoices = dclCard()?.Invoices ?? [];

        @let vehicleRegistrationNumber =
            dclFormGroup.controls.Garage?.controls?.VehicleRegistrationNumber
                ?.value ?? '';

        <!-- @let isForeign =
            dclFormGroup.controls.Garage?.controls?.IsForeign?.value ?? ''; -->

        <!-- @let customerId = dclFormGroup.controls.CustomerId?.value; -->

        <!-- <pre>
        customerId: {{ customerId }}
        selectedCustomer: {{ selectedCustomer()?._id }}
        </pre> -->

        <div class="flex flex-col gap-9">
            <!-- <z-invoice-card-customer
                class="flex flex-row gap-2"
                #invoiceCardCustomer
                [selectedCustomer]="selectedCustomer()"
                (customerSelected)="onCustomerSelected($event)"
            ></z-invoice-card-customer> -->

            @if (customerId != undefined || creationDateTime == undefined) {
                <z-customer-select
                    class="flex flex-auto grow"
                    #invoiceCardCustomer
                    [fetchSubjects]="true"
                    [label]="'Επιλογή Πελάτη'"
                    [formControlName]="'CustomerId'"
                    [searchable]="true"
                    [mode]="'lockedit'"
                    [selectedCustomer]="selectedCustomer()"
                    (rowDataSelect)="onCustomerSelected($event)"
                ></z-customer-select>
            }

            <z-car-registration-number
                [DCLCompletionDateTime]="completionDateTime"
                [selectedCustomer]="selectedCustomer()"
                (registrationNumberSelected)="
                    onRegistrationNumberSelected($event)
                "
            ></z-car-registration-number>

            @if (creationDateTime == undefined) {
                @if (vehicleRegistrationNumber.length > 3) {
                    <p-button
                        class="flex items-center justify-center"
                        label="Είσοδος Οχήματος"
                        (onClick)="sendNewClient()"
                        severity="success"
                        [style]="{
                            height: '85px',
                            width: '160px'
                        }"
                    />
                }
            } @else {
                <!-- Παρεχόμενη Υπηρεσία & Υποκατάστημα. -->
                @if ((branches()?.length ?? 0) > 0) {
                    <div class="flex flex-row gap-4 justify-between">
                        <z-service-recurring
                            class="w-6"
                            [formControlName]="'ServiceRecurring'"
                        ></z-service-recurring>

                        <z-branch-select
                            class="w-6"
                            [formControlName]="'BranchId'"
                            [autoSelectBranch]="true"
                            [readonly]="completionDateTime != undefined"
                            (optionsChange)="branches.set($event)"
                        ></z-branch-select>
                    </div>
                }
                <!-- <z-dcl-off-site-provided-service-selector></z-dcl-off-site-provided-service-selector> -->

                <div class="flex flex-col grow gap-5 justify-center">
                    <!-- @let responses = dclCard()?.Responses?.length ?? 0;
                @let responseIndex = responses > 0 ? responses - 1 : 0;                
                @let lastNewClientDclID =
                    dclCard()?.Responses?.[responseIndex]?.NewClientDclID; -->

                    <!-- @if (DCLNewId != undefined) {
                    <z-float-label
                        [label]="'Αριθμός Ψηφιακού Πελατολογίου'"
                        [readonly]="true"
                        [formControlName]="'DCLNewId'"
                    ></z-float-label>
                } -->

                    @if (DCLNewId != undefined) {
                        <z-dcl-off-site-provided-service-selector></z-dcl-off-site-provided-service-selector>

                        @if (providedServiceCategory == 5) {
                            <div class="flex grow">
                                <z-float-label-notes
                                    [rows]="3"
                                    [maxlength]="300"
                                    [readonly]="completionDateTime != undefined"
                                    [label]="
                                        'Περιγραφή Κατηγορίας Παρεχόμενων Υπηρεσιών'
                                    "
                                    formControlName="ProvidedServiceCategoryOther"
                                ></z-float-label-notes>
                            </div>
                        }
                    }
                </div>
            }
        </div>
        <div class="flex flex-col grow mt-4">
            <div class="flex flex-row gap-2 grow">
                <div id="vehicle-exit-panel" class="flex flex-col gap-2 grow">
                    @if (
                        creationDateTime != undefined &&
                        vehicleRegistrationNumber.length > 3
                    ) {
                        @if (
                            providedServiceCategory == 1 ||
                            providedServiceCategory == 2 ||
                            providedServiceCategory == 3
                        ) {
                            <label
                                class="flex justify-center label-active-color label-active-font-size label-active-font-weight"
                            >
                                <!-- @if (completionDateTime == undefined) {
                                Εξοδος Οχήματος & Επιλογή Έιδος Παραστατικών
                            } @else {
                                Επιλογή Παραστατικών
                            } -->
                            </label>

                            @if (invoicesIssuedCount() == 0) {
                                <!-- Θέλουμε να μπορούμε να γυρίσουμε τα παραστατικά σε άλλο τύπο -->
                                <div class="flex gap-6 justify-center mt-2">
                                    @let customerLegalType =
                                        selectedCustomer()?.LegalType;

                                    <!-- INDM -->
                                    @if (
                                        customerLegalType != 'IND' ||
                                        customerLegalType == undefined
                                    ) {
                                        <p-button
                                            class="flex items-center justify-center"
                                            label="{{
                                                completionDateTime == undefined
                                                    ? 'Έξοδος Οχήματος με Τιμολόγιο'
                                                    : 'Τιμολόγιο'
                                            }}"
                                            title="Πατήστε για να ολοκληρώσετε την καταχώρηση στο Ψηφιακό Πελατολόγιο και να ενημερώσετε την Α.Α.Δ.Ε ότι το όχημα δεν βρίσκεται πλέον εντός της εγκατάστασης"
                                            (onClick)="
                                                updateInvoiceKind(
                                                    'invoice',
                                                    'dcl-modal'
                                                )
                                            "
                                            severity="warn"
                                            [style]="{
                                                height: '85px',
                                                width: '160px'
                                            }"
                                            [disabled]="
                                                providedServiceCategory ==
                                                undefined
                                            "
                                        />
                                    }
                                    <!-- bindCDLWithInvoices -->
                                    @if (
                                        customerLegalType == 'INDM' ||
                                        customerLegalType == 'IND' ||
                                        customerLegalType == undefined
                                    ) {
                                        <p-button
                                            class="flex items-center justify-center"
                                            label="{{
                                                completionDateTime == undefined
                                                    ? 'Έξοδος Οχήματος με Παραστατικό Λιανικής'
                                                    : 'Παραστατικό Λιανικής'
                                            }}"
                                            title="Πατήστε για να ολοκληρώσετε την καταχώρηση στο Ψηφιακό Πελατολόγιο και να ενημερώσετε την Α.Α.Δ.Ε ότι το όχημα δεν βρίσκεται πλέον εντός της εγκατάστασης"
                                            (onClick)="
                                                updateInvoiceKind(
                                                    'receipt',
                                                    'dcl-modal'
                                                )
                                            "
                                            severity="info"
                                            [style]="{
                                                height: '85px',
                                                width: '160px'
                                            }"
                                            [disabled]="
                                                providedServiceCategory ==
                                                undefined
                                            "
                                        />
                                    }
                                </div>
                            } @else {
                                <p-button
                                    class="flex items-center justify-center"
                                    label="{{
                                        completionDateTime == undefined
                                            ? invoices[0].TypeCode == '1.1' ||
                                              invoices[0].TypeCode == '2.1'
                                                ? 'Έξοδος Οχήματος με Τιμολόγιο'
                                                : 'Έξοδος Οχήματος με Παραστατικό Λιανικής'
                                            : invoices[0].TypeCode == '1.1' ||
                                                invoices[0].TypeCode == '2.1'
                                              ? 'Παραστατικά Τιμολογιών'
                                              : 'Παραστατικά Απόδειξων'
                                    }}"
                                    title="Πατήστε για να ολοκληρώσετε την καταχώρηση στο Ψηφιακό Πελατολόγιο και να ενημερώσετε την Α.Α.Δ.Ε ότι το όχημα δεν βρίσκεται πλέον εντός της εγκατάστασης"
                                    severity="warn"
                                    (onClick)="
                                        updateInvoiceKind(
                                            invoices[0].TypeCode == '1.1' ||
                                                invoices[0].TypeCode == '2.1'
                                                ? 'invoice'
                                                : 'receipt',
                                            'dcl-modal'
                                        )
                                    "
                                    [style]="{ height: '85px', width: '160px' }"
                                    [disabled]="
                                        providedServiceCategory == undefined
                                    "
                                />
                            }
                            @if (invoices.length > 0) {
                                <label
                                    class="flex flex-col grow gap-2 label-active-color label-active-font-size label-active-font-weight"
                                >
                                    @for (invoice of invoices; track invoice) {
                                        @if (invoice.Series != undefined) {
                                            <span class="flex justify-center">
                                                Σειρά:&nbsp;
                                                <b>{{ invoice.Series }}</b
                                                >&nbsp;&nbsp; Αριθμός:&nbsp;
                                                <b>{{ invoice.AA }}</b
                                                >&nbsp;&nbsp; Μ.ΑΡ.Κ.:&nbsp;
                                                <b>
                                                    @if (
                                                        invoice.Response
                                                            ?.InvoiceMark == 0
                                                    ) {
                                                        Σε αναμονή Πληρωμής μέσω
                                                        POS
                                                    } @else {
                                                        {{
                                                            invoice.Response
                                                                ?.InvoiceMark ??
                                                                'N/A'
                                                        }}
                                                    }
                                                </b>
                                            </span>
                                        }
                                    }
                                </label>

                                <!-- {{ invoicesIssuedCount() }}
                            Πλήθος Παραστατικών: {{ invoices.length }} -->
                                <!-- <p-button
                            class="flex items-center justify-center"
                            label="{{
                                completionDateTime == undefined
                                    ? invoices[0].TypeCode == '1.1' ||
                                      invoices[0].TypeCode == '2.1'
                                        ? 'Έξοδος Οχήματος με Τιμολόγιο'
                                        : 'Έξοδος Οχήματος με Απόδειξη'
                                    : invoices[0].TypeCode == '1.1' ||
                                        invoices[0].TypeCode == '2.1'
                                      ? 'Τιμολόγιο'
                                      : 'Απόδειξη'
                            }}"
                            title="Πατήστε για να ολοκληρώσετε την καταχώρηση στο Ψηφιακό Πελατολόγιο και να ενημερώσετε την Α.Α.Δ.Ε ότι το όχημα δεν βρίσκεται πλέον εντός της εγκατάστασης"
                            severity="warn"
                            (onClick)="
                                updateInvoiceKind(
                                    invoices[0].TypeCode == '1.1' ||
                                        invoices[0].TypeCode == '2.1'
                                        ? 'invoice'
                                        : 'receipt',
                                    'dcl-modal'
                                )
                            "
                            [style]="{ height: '85px', width: '160px' }"
                            [disabled]="providedServiceCategory == undefined"
                        /> -->
                            } @else {}
                        } @else {
                            <!-- <label class="flex justify-center"
                        >Ημερομηνία Εξόδου</label
                    > -->

                            @if (
                                DCLNewId != undefined &&
                                providedServiceCategory != undefined &&
                                completionDateTime == undefined
                            ) {
                                <p-button
                                    class="flex items-center justify-center"
                                    label="Έξοδος Οχήματος"
                                    title="Πατήστε για να ολοκληρώσετε την καταχώρηση στο Ψηφιακό Πελατολόγιο και να ενημερώσετε την Α.Α.Δ.Ε ότι το όχημα δεν βρίσκεται πλέον εντός της εγκατάστασης"
                                    (onClick)="completeDCL2()"
                                    severity="success"
                                    icon="pi pi-sign-out"
                                    iconPos="right"
                                    [style]="{ height: '65px', width: '180px' }"
                                    [disabled]="
                                        providedServiceCategory == undefined
                                    "
                                />
                            } @else {
                                <!-- <label
                            class="flex flex-auto justify-center"
                            style="color: var(--p-button-success-background)"
                            ><b>{{
                                completionDateTime == undefined
                                    ? 'Ν/Α'
                                    : (completionDateTime | zDate: 'short')
                            }}</b></label
                        > -->
                            }
                        }
                    }
                </div>
            </div>
        </div>

        <div class="flex1 flex-col1 gap-8_ w-full_ py-4_">
            <!-- <zion-z-dcl-entry-date-time
        [formControlName]="'CreationDateTime'"
    ></zion-z-dcl-entry-date-time> -->

            <!-- @for (invoice of dclCard()?.Invoices; track invoice) {
            <a
                >{{ invoice?.TypeCode }} {{ invoice?.Series }}-{{
                    invoice?.AA
                }}</a
            >
        } -->

            @if (dclCard()?.Responses?.[0] != undefined) {
                <!-- <div class="flex flex-column gap-4 flex-auto"> -->
                <!-- {{ dclFormGroup?.controls?.ProvidedServiceCategory?.value }} -->
                <!-- <div class="flex flex-row gap-3 flex-auto">
                    <z-dcl-provided-service-category-selector></z-dcl-provided-service-category-selector>

                    

                    <z-float-label-currency
                        [label]="'Συμφωνηθέν Ποσό'"
                        [formControlName]="'Amount'"
                    ></z-float-label-currency>

                    <z-checkbox
                        [formControlName]="'NonIssueInvoice'"
                        [label]="'Μη έκδοση παραστατικού'"
                    ></z-checkbox>                    
                </div> -->
                <!-- TODO: invoiceKind Είδος Παραστατικού-->
                <!-- TODO: reasonNonIssueType Αιτιολογία Μη έκδοσης Παραστατικού -->

                <!-- @if (
                    dclFormGroup?.controls?.ProvidedServiceCategory?.value == 5
                ) {
                    <div class="flex flex-auto">
                        <z-float-label
                            [label]="
                                'Περιγραφή Κατηγορίας Παρεχόμενων Υπηρεσιών'
                            "
                            formControlName="ProvidedServiceCategoryOther"
                        ></z-float-label>
                    </div>
                } -->
                <!-- <div class="flex flex-auto">
                    <z-dcl-off-site-provided-service-selector></z-dcl-off-site-provided-service-selector>
                </div> -->
                <!-- </div> -->
            }
            <!-- <div class="flex flex-col md:flex-row gap-4">
        <div class="flex flex-wrap gap-2 w-full">
            <label for="firstname2">Firstname</label>
            <input pInputText id="firstname2" type="text" />
        </div>
        <div class="flex flex-wrap gap-2 w-full">
            <label for="lastname2">Lastname</label>
            <input pInputText id="lastname2" type="text" />
        </div>
    </div>

    <div class="flex flex-wrap">
        <label for="address">Address</label>
        <textarea pTextarea id="address" rows="4"></textarea>
    </div>

    <div class="flex flex-col md:flex-row gap-4">
        <div class="flex flex-wrap gap-2 w-full">
            <label for="state">State</label>
            <p-select id="state" [(ngModel)]="dropdownItem" [options]="dropdownItems" optionLabel="name" placeholder="Select One" class="w-full"></p-select>
        </div>
        <div class="flex flex-wrap gap-2 w-full">
            <label for="zip">Zip</label>
            <input pInputText id="zip" type="text" />
        </div>
    </div> -->
        </div>
    </div>
}
